import { Constants, ShowTypes } from "@eagerdog/constants";
import { IShow } from "@eagerdog/interfaces";
import { IEventRegisterRow } from "../../../services/helper.service";

export namespace ASFAFieldTrial {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    const asfaFieldTrial =
      ShowTypes[Constants.sanctioning_club.ASFA]?.[Constants.show_type.field_trial] || {};

    const stakesOptions = ((asfaFieldTrial[Constants.dog_class_element.asfa_stakes] || []) as string[])
      .map((level) => ({ value: level, id: level }));

    const additionalStakesOptions = ((asfaFieldTrial[Constants.dog_class_element.asfa_additional_stakes] || []) as string[])
      .map((level) => ({ value: level, id: level }));

    const isElementAvailable = (element: string) => {
      if (!show?.show_elements || show.show_elements.length === 0) return true;
      return show.show_elements.some((se) => se.show_element === element);
    };

    const rows: IEventRegisterRow[] = [];

    if (isElementAvailable(Constants.dog_class_element.asfa_stakes)) {
      rows.push({
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.asfa_stakes,
            multiSelect: false,
            options: stakesOptions,
          },
        ],
      });
    }

    if (isElementAvailable(Constants.dog_class_element.asfa_additional_stakes)) {
      rows.push({
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.asfa_additional_stakes,
            multiSelect: true,
            options: additionalStakesOptions,
          },
        ],
      });
    }

    const yesNoOptions = [
      { value: "Yes", id: "yes" },
      { value: "No", id: "no" },
    ];

    rows.push(
      {
        inputs: [
          {
            id: "asfa_first_trial_for_hound",
            type: "checkbox",
            label:
              "Check if this is the first ASFA trial for this hound. Certification/waiver applies to Open, Veteran, or Provisional entries.",
            multiSelect: false,
            options: yesNoOptions,
          },
        ],
      },
      {
        inputs: [
          {
            id: "asfa_first_time_entry",
            type: "checkbox",
            label:
              "Check if this is a first-time entry. A copy of official registration must accompany entry unless NGA.",
            multiSelect: false,
            options: yesNoOptions,
          },
        ],
      },
      {
        inputs: [
          {
            id: "asfa_info_changed_since_last_trial",
            type: "checkbox",
            label: "Check if any information has changed since the last ASFA trial entry.",
            multiSelect: false,
            options: yesNoOptions,
          },
        ],
      },
      {
        inputs: [
          {
            id: "asfa_info_changed_regarding",
            type: "text",
            label: "Regarding",
            options: [],
          },
        ],
      },
      {
        inputs: [
          {
            id: "asfa_dismissed_last_6_trials",
            type: "checkbox",
            label:
              "Check if this hound has been dismissed within the last 6 trials entered (clean-trial qualifier).",
            multiSelect: false,
            options: yesNoOptions,
          },
        ],
      }
    );

    return rows;
  };
}

